(function (ng) {
    const BREAKABLE_CHARACTERS = /\+|\\|\//g;

    ng.module('evo.Shared.Filters').filter('wrappable', function () {
        return function (input) {
            input = input || '';
            return input.replace(BREAKABLE_CHARACTERS, (match) => '\u200b' + match);
        };
    });
})(angular);